"use client";
import {
  Flex,
  FlexProps,
  FormLabel,
  FormLabelProps,
  Input,
  InputProps,
} from "@chakra-ui/react";
import { camelCase } from "change-case";
import { UseFormRegisterReturn } from "react-hook-form";

export interface SingleFormFieldProps extends FlexProps {
  htmlFor: string;
  label: string;
  type: string; //ex. text, email
  placeholder?: string;
  defaultValue?: string;
  register?: UseFormRegisterReturn<string>; //object created from react hook form's register function
  labelSx?: FormLabelProps;
  inputSx?: InputProps;
  formFor?: string;
  setInputValues?: (e: any) => void;
  inputValues?: any;
  setEmail?: (e: string) => void;
}
export const SingleFormField = (props: SingleFormFieldProps) => {
  const {
    htmlFor,
    label,
    type,
    placeholder,
    defaultValue,
    register,
    labelSx,
    inputSx,
    formFor,
    setInputValues,
    inputValues,
    setEmail,
    ...rest
  } = props;
  return (
    <Flex direction="column" align="start" flexGrow="1" {...rest}>
      <FormLabel
        htmlFor={htmlFor}
        {...labelSx}
        _readOnly={{ fontWeight: "light" }}
      >
        {label}
      </FormLabel>
      <Input
        id={htmlFor}
        {...{ type, placeholder, defaultValue }}
        {...register}
        {...inputSx}
        _readOnly={{
          fontWeight: "bold",
          borderColor: formFor === "enterprise" ? "none" : "gray.100",
          _hover: { borderColor: "gray.100" },
        }}
        onChange={(e: any) => {
          setInputValues
            ? setInputValues((prevState: any) => ({
                ...prevState,
                [`${htmlFor}`]: e.target.value,
              }))
            : undefined;
          htmlFor === "email" && setEmail ? setEmail(e.target.value) : null;
        }}
        value={
          formFor === "enterprise"
            ? label === "Email Address"
              ? inputValues[`email`]
              : inputValues[`${camelCase(label)}`]
            : undefined
        }
      />
    </Flex>
  );
};
